export const env = {
  API_ENDPOINT_URL: process.env.REACT_APP_API_ENDPOINT_URL,
  API: process.env.REACT_APP_API + "/api",
  WS: process.env.REACT_APP_WS,
};
